export default function createBlobFromCanvas(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise<Blob>((resolve, reject) => {
    if (canvas.toBlob === undefined) {
      resolve((canvas as any).msToBlob());
      return;
    }

    canvas.toBlob((result) => {
      if (result === null) {
        reject(new Error('Failed to get blob.'));
        return;
      }

      resolve(result);
    });
  });
}
